// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab_container[data-v-69ee9c78] {\n  padding: 10px;\n}\n.tab_container .tabs_css[data-v-69ee9c78] {\n  background: #fff;\n  padding: 10px;\n}\n.tab_container .tabs_css .pane_css[data-v-69ee9c78] {\n  height: calc(100vh - 45px - 95px);\n}", ""]);
// Exports
module.exports = exports;
